import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexWrapper } from './styled';

export const Link: React.FC = () => {
  return (
    <FlexWrapper>
      <FormattedMessage id={'app.url'} />
    </FlexWrapper>
  );
};

export default Link;
